import SvgIcon from '@/components/SvgIcon'

// require.context 函数：
//
//     require.context 是 Webpack 提供的一个函数，用于动态导入模块。它接受三个参数：
//         第一个参数 './svg'：指定要搜索的目录，这里表示从当前文件所在目录下的 svg 文件夹中搜索文件。
//         第二个参数 false：表示是否要递归搜索子目录，false 表示不递归搜索。
//         第三个参数 /\.svg$/：是一个正则表达式，用于匹配文件扩展名，这里表示只匹配扩展名为 .svg 的文件。
//     require.context 函数返回一个函数 svgRequired，该函数可以用于导入匹配的模块。
//
// svgRequired.keys()：
//
//     svgRequired.keys() 方法返回一个数组，包含了所有匹配的文件路径。
//
// forEach 循环：
//
//     使用 forEach 方法遍历 svgRequired.keys() 返回的数组，对每个匹配的文件路径调用 svgRequired(item)，从而动态导入这些 SVG 文件。

// 通常在 Webpack 构建过程中，会使用 svg - sprite - loader 这类加载器来处理这些 SVG 文件。
// svg - sprite - loader 的作用是将所有的 SVG 文件合并成一个 SVG 精灵图（SVG Sprite），并且会为每个 SVG 元素生成一个唯一的 ID。
// 默认情况下，svg - sprite - loader 会把 SVG 文件的文件名（不包含扩展名）作为基础，再加上特定的前缀，生成最终的 ID。
// 假设配置中设置的前缀是 icon-，那么 user.svg 在 SVG 精灵图中对应的元素 ID 就会是 icon-user。
const svgRequired = require.context('./svg', false, /\.svg$/)
svgRequired.keys().forEach((item) => svgRequired(item))

export default (app) => {
    // 为程序添加了一个svg-icon的标签，执行的脚本对应SvgIcon
    app.component('svg-icon', SvgIcon)
}
